/* global plausible */

export function initPlausibleForLanguageSites() {
  window.plausible =
    window.plausible ||
    ((...args) => {
      window.plausible.q = (window.plausible.q || []).push(args)
    })
  const origin = window.location.origin
  const lang = document.documentElement.lang
  const path = window.location.pathname
  window.plausiblePath = `${origin}/${lang}${path}`
  plausible("pageview", { u: window.plausiblePath + window.location.search })
}

export function initPlausibleCustomEvents() {
  if (plausible)
    document.body.addEventListener("click", (e) => {
      const button = e.target.closest(".plausible.button")
      if (button)
        plausible("ButtonClick", {
          props: { href: button.href, label: button.dataset.label },
        })
    })
}
